export default import.meta.ROLLDOWN_FILE_URL_ffjd20BZfghNiCzGd8o8YQ